// let baseURL = "http://127.0.0.1:8000"
let baseURL = 'https://pokemenunite.ldhtst.xyz'

export default baseURL


// WEBPACK FOOTER //
// ./src/utils/baseURL.js